<style lang="less">
	video{
		max-width: 100% !important;
		background-repeat: no-repeat;
		margin-right: auto;
		margin-right: auto;
	}

 </style>

 <template>
	<div v-if="user">
			<v-card v-if="appointment">
				<v-stepper v-model="stepValue">
					<v-stepper-header>
						<v-stepper-step step="1">
							Welcome
						</v-stepper-step>
						<v-divider/>
						<v-stepper-step step="2">
							Scheduling
						</v-stepper-step>
						<v-divider/>
						<v-stepper-step step="3">
							Consent
						</v-stepper-step>
						<v-divider/>
						<v-stepper-step step="4">
							{{ appointment.methodology == 'face-to-face' ? 'Location' : 'Communication' }}
						</v-stepper-step>
						<v-divider/>
						<v-stepper-step step="5">
							Payment Details
						</v-stepper-step>
						<v-divider/>
						<v-stepper-step step="6">
							Complete Set Up
						</v-stepper-step>
					</v-stepper-header>
					<v-stepper-content step="1">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<p>This tool will guide you through the set up for your upcoming appointment.</p>
							<p>To get started, click 'continue'</p>
						</v-card>
						<v-btn color="primary" @click="stepUp">Continue</v-btn>
					</v-stepper-content>
					<v-stepper-content step="2">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<v-alert dense color="white" style="font-size: 1.3em; font-weight: 300">
								This appointment is scheduled for {{ appointment.dateTime.toDate() | moment("dddd D/MM/YYYY") }} at {{ appointment.dateTime.toDate() | moment("HH:mm") }}
							</v-alert>
							<p>There are a number of people involved in organising research and missed appointments cause a lot of disruption and inconvenience. If you are not going to be able to make your appointment we ask that you let us know as soon as possible by phone or <a  target="blank" href="mailto:talk@m.works">email</a>.</p>
							<p>Rescheduling a missed appointment is not always possible </p>

						</v-card>
						<v-btn icon @click="stepBack" class="mr-1"><v-icon>mdi-arrow-left-circle</v-icon></v-btn>
						<v-btn color="green" dark class="mr-2" link :href="calendarLink" target="blank">
							<v-icon small class="mr-1">mdi-google</v-icon>Add to gCal</v-btn>
						<v-btn color="primary" @click="stepUp">Continue</v-btn>

					</v-stepper-content>
					<v-stepper-content step="3">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<p>Please take the time to read this consent notice.</p>
							<div v-if="appointment.consentNotice">{{appointment.consentNotice}}</div>
							<div v-else>
								Standard Consent
							</div>					
							<v-alert dense color="white">
								<v-checkbox v-model="consentGranted" label="I have read the provided notices and I give my consent to take part in this research"></v-checkbox>
							</v-alert>
						</v-card>
						<v-btn icon @click="stepBack" class="mr-1"><v-icon>mdi-arrow-left-circle</v-icon></v-btn>
						<v-btn color="primary" @click="stepUp" :disabled="!consentGranted">Continue</v-btn>
					</v-stepper-content>
					<v-stepper-content step="4">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<div v-if="appointment.methodology == 'face-to-face'">
								<div v-if="location">
									<p>The appointment will be held at the following location: </p>
									<p>
									{{location.name}}<br/>
									<span v-if="location.address1">{{location.address1}}<br/></span>
									<span v-if="location.address2">{{location.address2}}<br/></span>
									<span v-if="location.city">{{location.city}}<br/></span>
									<span v-if="location.postcode">{{location.postcode}}</span>
									</p>
									<p v-if="location.intro">{{location.intro}}</p>
								</div>
							</div>
							<div v-if="appointment.methodology == 'video'">
								<p>This is a video appointment. Please take the time to complete the video test below</p>
								<VideoTest :id="ref" v-on:complete="stepUp"></VideoTest>
							</div>			
							<div v-if="appointment.methodology == 'phone'">
								<p>This is a telephone interview.</p>
								<p>The telephone number we have saved for you is: {{userDetails.phone}}. You can update your contact details by visiting your <a target="blank" href="/profile">profile</a> or provide an alternative contact number for this appointment only below.</p>
								<v-text-field solo rounded v-model="participantPhone" label="Alternative Phone Number"></v-text-field>
								<p>Please ensure that you are in a quiet place where you have good phone reception and will be undisturbed for the duration of the interview. Please do not try to complete the interview while driving.</p>
							</div>					
						
						</v-card>
						<v-btn icon @click="stepBack" class="mr-1"><v-icon>mdi-arrow-left-circle</v-icon></v-btn>
						<v-btn v-if="appointment.methodology == 'face-to-face' &&  location && location.mapLink" color="green" dark link :href="location.mapLink" target="blank" class="mr-1"><v-icon small class="mr-1">mdi-google</v-icon>View On Map</v-btn>
						<v-btn color="primary" @click="stepUp">Continue</v-btn>
					</v-stepper-content>					
					<v-stepper-content step="5">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<IncentiveForm :details="incentiveDetails"></IncentiveForm>
						</v-card>
						<v-btn icon @click="stepBack" class="mr-1"><v-icon>mdi-arrow-left-circle</v-icon></v-btn>
						<v-btn color="primary" @click="stepUp">Continue</v-btn>
					</v-stepper-content>

					<v-stepper-content step="6">
						<v-card color="grey lighten-3" class="mb-5 pa-4" min-height="200px">
							<p>Thank you! Click 'finish' to complete this set up</p>
						</v-card>
						<v-btn icon @click="stepBack" class="mr-1"><v-icon>mdi-arrow-left-circle</v-icon></v-btn>
						<v-btn color="primary" @click="save">Finish</v-btn>
					</v-stepper-content>
				</v-stepper>
			</v-card>
			<v-card v-else class="pa-4">
				Appointment not found, please contact Meisterworks
			</v-card>
	</div>
</template>

<script>
	import firebase from "firebase";
	import Vue from "vue";
	import Vuex from "vuex";
	import VideoTest from "../communication/video/VideoTest.vue";
	import IncentiveForm from "../forms/IncentiveForm.vue";
	export default {
		name: "ParticipantStepper",
		props: ["ref"],
		components: {
			VideoTest, 
			IncentiveForm
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				user: state => state.auth.user, 
				userDetails: state => state[state.auth.view].user,
				appointments: state => state.panelmember ? state.panelmember.appointments : [],
				projects: state => state.panelmember ? state.panelmember.projects : [],
				locations: state => state.panelmember ? state.panelmember.locations : [],
			}),
			appointment(){
				var aid = this.ref;
				return this.appointments.find( a => a.id == aid)
			},
			location(){
				if( !this.project ){
					return;
				}
				var lid = this.project.location;
				return this.locations.find( a => a.id == lid)
			},
			project(){
				if( !this.appointment ){
					return;
				}
				var pid = this.appointment.project;
				return this.projects.find( p => p.id == pid)
			},
			calendarLink(){
				if( !this.appointment ){
					return;
				}
				var start = Vue.moment( this.appointment.dateTime.toDate() ).format( "YYYYMMDTHHmm00" );
				var duration = this.appointment.duration || 60;
				var end = Vue.moment( new Date( this.appointment.dateTime.toDate() ) ).add(duration, "minutes").format( "YYYYMMDTHHmm00" );
				var link = `http://www.google.com/calendar/event?action=TEMPLATE&text=Meisterworks%20Appointment&ctz=Europe/London&dates=${start}%2F${end}&`;
					link += `&details=`;
					if( this.project  ){
						link += this.project.participantName
					}
					link += "<br/>beta.m.works<br/>talk@m.works";
					if( this.appointment.methodology == "face-to-face"){
						if( this.project  ){
							link += `&location=${this.project.location}`
						}
					}
					else{
						link += `&location=beta.m.works`
					}
				return link;
			}
		},
		data: () => {
			return {
				stepValue: 1, 
				consentGranted: false, 
				participantPhone: '', 
				incentiveDetails: {}
			}
		},
		methods: {
			stepBack(){
				this.stepValue--;
			},
			stepUp(){
				this.stepValue++;
			}, 
			save(){
				const self = this;
				var data = {
					participantSetUpComplete: firebase.firestore.Timestamp.fromDate(new Date()),
				}
				data.incentiveDetails = self.incentiveDetails
				
				if( self.consentGranted ){
					data.consentGranted = true;
				}
				if( self.participantPhone ){
					data.participantPhone = self.participantPhone;
				}
						
				self.$store.dispatch("updateDoc", {
					doc: "appointments/"+self.ref, 
					data: data, 
					action: "update"
				}).then( () => {
					self.$router.push( "/" )
				})
			}
		},
		watch: {
			view: function(nv){
				if( nv !== 'panelmember' ){
					this.$router.replace({ name: "home" });
				}
				this.$store.dispatch( 'fetchAppointments' );
			},
			appointment(){
				if( this.appointment ){
					this.$store.dispatch( 'fetchProject', this.appointment.project );
				}
			},
		}
	}
</script>